module.exports = __webpack_public_path__ + "img/layout-6_5.a46de5a9.png";